import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { isSearchSection, searchSectionByType } from '../config/search.js';

export function normalizeSearchQuery(query = {}) {
  const q = String(query.q || '').trim();
  const sectionValue = String(query.section || searchSectionByType[String(query.type || '')]?.id || '');
  const section = isSearchSection(sectionValue) ? sectionValue : '';
  const page = Math.max(1,Number.parseInt(query.page,10) || 1);
  return { q, section, page };
}

export function buildSearchQuery({ q='', section='', page=1 } = {}) {
  const cleanQuery = String(q).trim();
  const cleanSection = isSearchSection(section) ? section : '';
  const safePage = Math.max(1,Number.parseInt(page,10) || 1);
  return {
    ...(cleanQuery && { q:cleanQuery }),
    ...(cleanSection && { section:cleanSection }),
    ...((cleanQuery || cleanSection || safePage > 1) && { page:String(safePage) })
  };
}

export function useSearchQuery() {
  const route = useRoute();
  const router = useRouter();
  const searchQuery = computed(() => normalizeSearchQuery(route.query));
  const navigate = (value, { replace=false } = {}) => router[replace ? 'replace' : 'push']({
    name:'search',
    query:buildSearchQuery(value)
  });
  return { searchQuery, navigate };
}
